import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { debounce, getTextNodesIn } from '../functions'

imagesLoaded.makeJQueryPlugin($)

let iso = ''

const parent = $('.js-search-container')
if (parent.length != 0) {
    iso = new Isotope('.js-search-container', {
        itemSelector: '.feed-search',
        percentPosition: true,
        layoutMode: 'fitRows',
    })
    parent.imagesLoaded(function () {
        iso.layout()
    })

    const filterItems = function () {
        const catVals = $('.page-filter .categories li.active a').map(function() {
            return $(this).attr('data-categories');
        }).get();

        const searchVal = $('.services-search').val() || ''
        const qsRegex = new RegExp(searchVal, 'gi')

        iso.arrange({
            filter: function () {
                const item = $(this)
                const attr = item.attr('data-categories')
                const categories = attr ? attr.split(',').map(Number) : []
                let hasCategory = false

                if (catVals.length === 0 || catVals.includes('all') || catVals[0] === '') {
                    hasCategory = true
                } else {
                    for (let i = 0; i < catVals.length; i++) {
                        if (categories.includes(parseInt(catVals[i]))) {
                            hasCategory = true
                            break
                        }
                    }
                }

                const text = item.find('.search-link').attr('title')
                let hasText = qsRegex ? text.match(qsRegex) : true

                return hasCategory && hasText
            }
        })
    }

    $('.services-search').on('keyup', debounce(filterItems, 200))
    $('.services-search').on('blur', filterItems)

    let links = document.querySelectorAll('.page-filter .categories li a');
    if (links){
        links.forEach(function(link) {
            link.addEventListener('click', function(event) {
                event.preventDefault();
                let parentLi = this.parentElement;
                let isActive = parentLi.classList.contains('active');
                let siblings = parentLi.parentElement.children;

                for (let i = 0; i < siblings.length; i++) {
                    siblings[i].classList.remove('active');
                }

                if (!isActive) {
                    parentLi.classList.add('active');
                }

                filterItems();
            });
        });
    }
}
